


// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle,
//   TextField, IconButton, LinearProgress, CircularProgress,
//   Checkbox, FormControlLabel,
// } from '@mui/material';
// import { Edit, Delete } from '@mui/icons-material';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../../config';
// import api from '../../../api/axiosInterceptor';
// import axios from 'axios';

// export const SuperStaffOfficeOrdersComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);

//   const [formData, setFormData] = useState({
//     subject: '',
//     date_of_issue: '',
//     is_internal: false, // added checkbox field
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteOrder, setDeleteOrder] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 50 },
//     { id: 'subject', field: 'subject', headerName: 'Subject', width: 300 },
//     { id: 'dateOfIssue', field: 'dateOfIssue', headerName: 'Date of issue', width: 150 },
//     {
//       id: 'viewDetails',
//       field: 'viewDetails',
//       headerName: 'View Details',
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">
//             View Details
//           </a>
//         ) : (
//           'No File'
//         ),
//     },
//     {
//       id: 'is_internal',
//       field: 'is_internal',
//       headerName: 'Is Internal',
//       width: 100,
//       renderCell: (params) => (params.value ? 'Yes' : 'No'),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/staff-office-orders/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           subject: item.subject,
//           dateOfIssue: item.date_of_issue,
//           viewDetails: item.link || '',
//           is_internal: item.is_internal || false,
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch(() => {
//         setSnackbarMessage('Failed to load Office orders.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddOrder = () => {
//     setIsEditMode(false);
//     setFormData({ subject: '', date_of_issue: '', is_internal: false });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (order) => {
//     setIsEditMode(true);
//     setSelectedOrder(order);
//     setFormData({
//       subject: order.subject,
//       date_of_issue: order.dateOfIssue,
//       is_internal: order.is_internal || false,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (order) => {
//     setDeleteOrder(order);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/office-orders/${deleteOrder.id}/`)
//       .then(() => {
//         setSnackbarMessage('Office order deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchOrders();
//       })
//       .catch(() => {
//         setSnackbarMessage('Failed to delete office order.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteOrder(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.subject?.trim()) errors.subject = 'Subject is required';
//     if (!formData.date_of_issue) errors.date_of_issue = 'Date of issue is required';
//     if (!selectedFile && !isEditMode) errors.file = 'File is required';
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors((prev) => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('subject', formData.subject);
//     form.append('date_of_issue', formData.date_of_issue);
//     form.append('is_internal', formData.is_internal);
//     if (selectedFile) form.append('link', selectedFile);

//     try {
//       setUploading(true);
//       setUploadProgress(0);

//       if (isEditMode) {
//         await api.patch(`${API_BASE_URL}/home-notification/office-orders/${selectedOrder.id}/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage('Office order updated successfully.');
//       } else {
//         await api.post(`${API_BASE_URL}/home-notification/office-orders/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage('Office order added successfully.');
//       }

//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       fetchOrders();
//       setOpenFormDialog(false);
//     } catch {
//       setSnackbarMessage('Failed to submit office order.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   };

//   if (loading) return <LoadingSpinner size={30} />;

//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', backgroundColor: '#fff' }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195,234,203,0.1)" p={2}>
//         <Typography variant="h4" component="h1" fontWeight="bold">Office Orders</Typography>
//         <Button variant="contained" color="primary" onClick={handleAddOrder} disabled={uploading}>Add Order</Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
//       />

//       <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Office Order' : 'Add Office Order'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             label="Subject"
//             fullWidth
//             margin="dense"
//             value={formData.subject}
//             error={!!formErrors.subject}
//             helperText={formErrors.subject}
//             onChange={e => setFormData({ ...formData, subject: e.target.value })}
//             disabled={uploading}
//           />
//           <TextField
//             label="Date of Issue"
//             type="date"
//             fullWidth
//             margin="dense"
//             value={formData.date_of_issue}
//             error={!!formErrors.date_of_issue}
//             helperText={formErrors.date_of_issue}
//             onChange={e => setFormData({ ...formData, date_of_issue: e.target.value })}
//             InputLabelProps={{ shrink: true }}
//             disabled={uploading}
//           />
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.is_internal}
//                 onChange={(e) => setFormData({ ...formData, is_internal: e.target.checked })}
//                 disabled={uploading}
//               />
//             }
//             label="Is Internal"
//           />
//           <Box mt={2}>
//             <input
//               type="file"
//               accept="*"
//               onChange={handleFileChange}
//               disabled={uploading}
//               style={{ display: 'block', marginTop: 8 }}
//             />
//             {formErrors.file && <Typography variant="body2" color="error" sx={{ mt: 1 }}>{formErrors.file}</Typography>}
//             {isEditMode && !selectedFile && selectedOrder?.viewDetails && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a href={`${API_BASE_URL}${selectedOrder.viewDetails}`} target="_blank" rel="noopener noreferrer">View Details</a>
//               </Typography>
//             )}
//           </Box>
//           {uploading && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" align="center" sx={{ mt: 1 }}>
//                 Uploading... {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>Cancel</Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
//             {uploading ? <CircularProgress size={24} color="inherit" /> : isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this office order?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>Cancel</Button>
//           <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>Delete</Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, IconButton, LinearProgress, CircularProgress,
  Checkbox, FormControlLabel,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { API_BASE_URL } from '../../../config';
import api from '../../../api/axiosInterceptor';
import axios from 'axios';

export const SuperStaffOfficeOrdersComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [formData, setFormData] = useState({
    subject: '',
    date_of_issue: '',
    is_internal: false,
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteOrder, setDeleteOrder] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 50 },
    {
      id: 'type',
      field: 'type',
      headerName: 'Type',
      width: 100,
      renderCell: (params) => (
        <Typography variant="body2" fontWeight="bold" color={params.value === 'Staff' ? 'primary.main' : 'secondary.main'}>
          {params.value}
        </Typography>
      ),
    },
    { id: 'subject', field: 'subject', headerName: 'Subject', width: 300 },
    { id: 'dateOfIssue', field: 'dateOfIssue', headerName: 'Date of issue', width: 150 },
    {
      id: 'viewDetails',
      field: 'viewDetails',
      headerName: 'View Details',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            View Details
          </a>
        ) : (
          'No File'
        ),
    },
    {
      id: 'is_internal',
      field: 'is_internal',
      headerName: 'Is Internal',
      width: 100,
      renderCell: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchOrders();
  }, []);

  // ONLY fetchOrders modified to get from both APIs
  const fetchOrders = async () => {
    setLoading(true);
    
    try {
      const [staffResponse, publicResponse] = await Promise.all([
        axios.get(`${API_BASE_URL}/home-notification/staff-office-orders/`),
        axios.get(`${API_BASE_URL}/home-notification/office-orders/`)
      ]);

      const staffData = staffResponse.data.map((item, index) => ({
        id: item.id || index,
        slNo: index + 1,
        subject: item.subject,
        dateOfIssue: item.date_of_issue,
        viewDetails: item.link || '',
        is_internal: item.is_internal || true,
        type: 'Staff'
      }));

      const publicData = publicResponse.data.map((item, index) => ({
        id: item.id || staffData.length + index,
        slNo: staffData.length + index + 1,
        subject: item.subject,
        dateOfIssue: item.date_of_issue,
        viewDetails: item.link || '',
        is_internal: item.is_internal || false,
        type: 'Public'
      }));

      const combinedData = [...staffData, ...publicData];
      setRows(combinedData);
    } catch (error) {
      console.error('Failed to fetch office orders:', error);
      setSnackbarMessage('Failed to load Office orders.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddOrder = () => {
    setIsEditMode(false);
    setFormData({ subject: '', date_of_issue: '', is_internal: false });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleEdit = (order) => {
    setIsEditMode(true);
    setSelectedOrder(order);
    setFormData({
      subject: order.subject,
      date_of_issue: order.dateOfIssue,
      is_internal: order.is_internal || false,
    });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (order) => {
    setDeleteOrder(order);
    setDeleteDialogOpen(true);
  };

  // Uses ORIGINAL API endpoint for delete
  const handleDelete = () => {
    api
      .delete(`/home-notification/office-orders/${deleteOrder.id}/`)
      .then(() => {
        setSnackbarMessage('Office order deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchOrders();
      })
      .catch(() => {
        setSnackbarMessage('Failed to delete office order.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteOrder(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.subject?.trim()) errors.subject = 'Subject is required';
    if (!formData.date_of_issue) errors.date_of_issue = 'Date of issue is required';
    if (!selectedFile && !isEditMode) errors.file = 'File is required';
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
      setSelectedFile(null);
    } else {
      setFormErrors((prev) => ({ ...prev, file: null }));
      setSelectedFile(file);
    }
  };

  // Uses ORIGINAL API endpoints for create/update
  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const form = new FormData();
    form.append('subject', formData.subject);
    form.append('date_of_issue', formData.date_of_issue);
    form.append('is_internal', formData.is_internal);
    if (selectedFile) form.append('link', selectedFile);

    try {
      setUploading(true);
      setUploadProgress(0);

      if (isEditMode) {
        await api.patch(`/home-notification/office-orders/${selectedOrder.id}/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Office order updated successfully.');
      } else {
        await api.post(`/home-notification/office-orders/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Office order added successfully.');
      }

      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchOrders();
      setOpenFormDialog(false);
    } catch {
      setSnackbarMessage('Failed to submit office order.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) return <LoadingSpinner size={30} />;

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', backgroundColor: '#fff' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195,234,203,0.1)" p={2}>
        <Typography variant="h4" component="h1" fontWeight="bold">Office Orders (All)</Typography>
        <Button variant="contained" color="primary" onClick={handleAddOrder} disabled={uploading}>Add Order</Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? 'Edit Office Order' : 'Add Office Order'}</DialogTitle>
        <DialogContent>
          <TextField
            label="Subject"
            fullWidth
            margin="dense"
            value={formData.subject}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={e => setFormData({ ...formData, subject: e.target.value })}
            disabled={uploading}
          />
          <TextField
            label="Date of Issue"
            type="date"
            fullWidth
            margin="dense"
            value={formData.date_of_issue}
            error={!!formErrors.date_of_issue}
            helperText={formErrors.date_of_issue}
            onChange={e => setFormData({ ...formData, date_of_issue: e.target.value })}
            InputLabelProps={{ shrink: true }}
            disabled={uploading}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.is_internal}
                onChange={(e) => setFormData({ ...formData, is_internal: e.target.checked })}
                disabled={uploading}
              />
            }
            label="Is Internal (Staff Only)"
          />
          <Box mt={2}>
            <input
              type="file"
              accept="*"
              onChange={handleFileChange}
              disabled={uploading}
              style={{ display: 'block', marginTop: 8 }}
            />
            {formErrors.file && <Typography variant="body2" color="error" sx={{ mt: 1 }}>{formErrors.file}</Typography>}
            {isEditMode && !selectedFile && selectedOrder?.viewDetails && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{' '}
                <a href={selectedOrder.viewDetails} target="_blank" rel="noopener noreferrer">View Details</a>
              </Typography>
            )}
          </Box>
          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" align="center" sx={{ mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>Cancel</Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
            {uploading ? <CircularProgress size={24} color="inherit" /> : isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this office order?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>Cancel</Button>
          <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>Delete</Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
